import { EuiPage, EuiPageBody, EuiPageContent, EuiPageContentBody, EuiPageHeader, EuiPageHeaderSection, EuiTitle } from '@elastic/eui';
import React from 'react';

export const Page = (props) =>{

    const {title, scrollBody, children} = props;

    const bodyClass = scrollBody ? 'ContentBody scrollBody' : 'ContentBody'
    
    return(
        <EuiPage className="Page">
            <EuiPageBody>
            <EuiPageHeader style={{height:'10%'}}>
                <EuiPageHeaderSection>
                <EuiTitle size="l">
                <h1>{title || "SIN TITULO"}</h1>
                </EuiTitle>
                </EuiPageHeaderSection>
            </EuiPageHeader>
            <EuiPageContent borderRadius='none' hasShadow={true} paddingSize='s' className='Content'>
                <EuiPageContentBody className={bodyClass}>
                    {children !==undefined ? children : null}
                </EuiPageContentBody>
            </EuiPageContent>
            </EuiPageBody>
        </EuiPage>
    );
}